import loadExternal from './loadExternal';

const baseUrl = 'https://www.googletagmanager.com/gtag/js?id=';

function setup(id) {
  window.dataLayer = window.dataLayer || [];
  function gtag(args) {
    window.dataLayer.push(...args);
  }

  window.gtag = gtag;

  gtag('js', new Date());

  gtag('config', id);
}

function init(id) {
  loadExternal(`${baseUrl}${id}`, setup(id), document.body);
}

function emitConversion(idWithSuffix, value) {
  window.gtag('event', 'conversion', {
    send_to: idWithSuffix,
    value,
    currency: 'EUR'
  });
}

export default {
  init,
  emitConversion
};



// WEBPACK FOOTER //
// ./src/app/utils/googleGlobalSiteTag.js